import React, { useEffect } from "react";
import blog1 from "../../../Assets/newAsset/blog1.webp";
import moment from "moment";
import "./Blogs.css";
import { BsArrowRight } from "react-icons/bs";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { blogsAction } from "../../../Redux/Actions";
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Loader from "../../../components/Loader/Loader";
import { LazyLoadImage } from "react-lazy-load-image-component";

const blog = [
  {
    id: 1,
    img: blog1,
    title: "WHAT IS D-DIMER? ",
    name: "Author: Abhinav Srivastava",
    date: "06 Aug 2021",
    desc:
      "The ultimate guide to reduce d-dimer levels in covid-19. One must know the risks of higher d-dimer and how to reduce it.",
    slug: "how-to-reduce-d-dimer-levels-in-covid-19",
  },
];

//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 3,
  },
  desktopSmall: {
    breakpoint: { max: 1500, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Blog() {
  const blogdata = useSelector((state) => state.blogslist);
  // const {blogpackages} = blogdata

  // const data = blogdata.blogs
  const { blogs, loading } = blogdata;
  // console.log("blog data", blogs);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(blogsAction());
  }, []);

  return (
    <React.Fragment>
      {/** USE THIS CODE FOR API-DATA */}
      {loading ? (
        <Loader />
      ) : (
        <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={2500}
          transitionDuration={200}
          deviceType={"tablet"}
        >
          {blogs &&
            blogs.results &&
            blogs.results.map((values) => (
              <div
                className="Package__card Package__cardNew Package__cardNewTesi bgOrdinary"
                key={values.id}
              >
                <div className="Blog__card">
                  <div className="Blog__img Blog__imgBlog">
                    <LazyLoadImage
                      src={values.image}
                      alt={values.image}
                      defer
                    />
                  </div>
                  <div className="Blog__bottom Blog__bottomBottom">
                    <div className="Blog__title">
                      <Link className="Blog__title" to={`/blog/${values.slug}`}>
                        {values.blog_name}
                      </Link>
                    </div>
                    <div className="Blog__subHeader">
                      <span>{values.author_name}&nbsp;</span>
                      <span className="dot_padding" >•</span>
                      <span>
                        {moment(values.created_at).format("Do MMM  YYYY")}
                      </span>
                    </div>
                    <div className="Blog__desc Blog__descBlog">
                      {values.description.length < 70
                        ? values.description
                        : `${values.description.substring(0, 70)}...`}
                    </div>
                    <div className="Blog__footer">
                      <Link to={`/blog/${values.slug}`}>Read more</Link>
                      <BsArrowRight />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Carousel>
      )}
      {/** USE THIS CODE FOR STATIC API**/}
      {/* {blog.map((values) => (
        <div className="Blog" key={values.id}>
          <div className="Blog__card">
            <div className="Blog__img">
              <LazyLoadImage src={values.img} alt={values.img} delayTime='100'/>
            </div>
            <div className="Blog__bottom">
              <div className="Blog__title">{values.title}</div>
              <div className="Blog__subHeader">
                <span>{values.name}</span>
                <span>{values.date}</span>
              </div>
              <div className="Blog__desc">{values.desc}</div>
              <div className="Blog__footer">
                <Link to={`/blog/${values.slug}`}>Read more</Link>
                <BsArrowRight />
              </div>
            </div>
          </div>
        </div>
      ))} */}
    </React.Fragment>
  );
}

export default Blog;
